import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import SearchBox from "../search-box";
import NewsCard from "../events/events-card";
import ReactPaginate from "react-paginate";
import Api from '../../../lib/seam-api';
import CustomSelect from '../select';
import NoResults from '../no-results';
import {fireEnquireOpenEvent} from "../../overlay/enquire";

import NavItem from '../nav-link';

import OfficesEmpty from './office-empty';

class OfficeIndex extends Component {

    constructor(props) {
        super(props);

        this.state = {
            offices: [],
            pageCount: 1,
            page: 1,
            itemsPerPage: 16,
            direction: 'asc',
            order: null,
            sort: null,
        }
    }

    componentDidMount() {
        this.fetchDefault();
    }

    getSize(size) {
        size = size?.replace(' ', '');

        const sizes = {
            '1': {
                min_seats: 1,
                max_seats: 2,
            },
            '2-4': {
                min_seats: 2,
                max_seats: 4,
            },
            '5-11': {
                min_seats: 5,
                max_seats: 11,
            },
            '12-15': {
                min_seats: 12,
                max_seats: 15,
            },
            '16': {
                min_seats: 16,
                max_seats: 100,
            }
        }

        return sizes.hasOwnProperty(size) ? sizes[size] : null;
    }

    async fetchDefault() {
        const query = new URLSearchParams(window.location.search);
        const size = this.getSize(query.get('size'));
        console.log(size);
        let params = {
            page: this.state.page,
            perPage: this.state.itemsPerPage,
        }

        if (this.state.direction !== null && this.state.direction.length !== 0) {
            params.direction = this.state.direction;
        }

        if (this.state.order !== null && this.state.order.length !== 0) {
            params.orderBy = this.state.order;
        }

        if (size !== null && size !== undefined) {
            const { min_seats, max_seats } = size;

            params.min_seats = min_seats;
            params.max_seats = max_seats;
        }

        const { data, meta: { last_page, cdn_url } } = await Api.offices().get(params);

        this.setState({ offices: data, pageCount: last_page, cdn_url });
    }

    onSortChange(event) {
        const value = event.value;

        let params = {
            orderBy: null,
            direction: null,
        }

        if (typeof value == 'object') {
            const orderBy = value?.orderBy;
            const direction = value?.direction;

            if (orderBy) params.order = orderBy;
            if (direction) params.direction = direction;
        }

        this.setState(params, () => {
            this.fetchDefault();
        })
    }

    handlePageClick = (event) => {
        this.setState({ page: event.selected + 1 }, () => this.fetchDefault());
    }

    render() {
        return (
            <>
                <div className="index-top">
                    <h2 data-seam-tag={this.props.titleTag.split('data-seam-tag=')[1]}>{ this.props.title }</h2>

                    <div style={{ display: 'flex', gap: '20px' }}>
                        <CustomSelect placeholder="Sort Results By" value={this.state.sort} onChange={this.onSortChange.bind(this)} items={[
                                {
                                    option: 'Price (Low - High)',
                                    value: {
                                        orderBy: 'price',
                                        direction: 'asc',
                                    }
                                },
                                {
                                    option: 'Price (High - Low)',
                                    value: {
                                        orderBy: 'price',
                                        direction: 'desc',
                                    }
                                },
                                {
                                    option: 'Size (Low - High)',
                                    value: {
                                        orderBy: 'size_sqft',
                                        direction: 'asc',
                                    }
                                },
                                {
                                    option: 'Size (High - Low)',
                                    value: {
                                        orderBy: 'size_sqft',
                                        direction: 'desc',
                                    }
                                },
                                {
                                    option: 'Building (Low - High)',
                                    value: {
                                        orderBy: 'office_building_id',
                                        direction: 'asc',
                                    }
                                },
                                {
                                    option: 'Building (High - Low)',
                                    value: {
                                        orderBy: 'office_building_id',
                                        direction: 'desc',
                                    }
                                },
                        ]}/>

                        {/* <CustomSelect placeholder="Order results by" value={this.state.order} onChange={this.onOrderChange.bind(this)} items={[
                                {
                                    option: 'Price',
                                    value: 'price'
                                },
                                {
                                    option: 'Office',
                                    value: 'office_building_id'
                                },
                                {
                                    option: 'Size',
                                    value: 'size_sqft'
                                },
                        ]}/> */}
                    </div>
                </div>

                { this.state.offices.length > 0 && <div className="office-index__items">
                    { this.state.offices.map(office => {
                        let style = {}

                        const thumbnail = office?.page_content?.preview_images?.website_thumbnail;

                        if (thumbnail !== undefined) {
                            if (thumbnail.length == 1) {
                                style.backgroundImage = `url(${this.state.cdn_url}/images/${office?.page_content?.preview_images?.website_thumbnail[0].file_name})`;
                            }
                        }

                        return (
                            <div className="office-index__item" onClick={() => window.location.href = `/offices/${office?.id}`} style={style}>
                                <div className="office-index-item__overlay"></div>
                                <div className="office-index-item__top">{ office?.office_building?.name }</div>
                                <div className="office-index-item__content">
                                    <NavItem slug={`/offices/${office?.id}`} color="white" text="Discover" />

                                    <div className="office-index-item__bottom">
                                        <b>{ office?.name }</b>
                                        <div className="office-index-item__tags">
                                            { office?.price && <div className="office-index-item__tag">
                                                <div className="office-index-item-tag__circle"></div>
                                                £{ office?.price }
                                            </div> }
                                            { office?.size_sqft && <div className="office-index-item__tag">
                                                <div className="office-index-item-tag__circle"></div>
                                                { office?.size_sqft } { 'ft' + String.fromCharCode(178)}
                                            </div> }
                                        </div>
                                        <p className="office-index-item__room-mobile">{ office?.office_building?.name }</p>
                                    </div>
                                </div>
                            </div>
                        )
                    }) }
                </div> }

                { this.state.offices.length == 0 ? <OfficesEmpty/> :

                <ReactPaginate
                        breakLabel="..."
                        onPageChange={this.handlePageClick.bind(this)}
                        pageRangeDisplayed={5}
                        pageCount={this.state.pageCount}
                        nextLabel={<img src='/images/blocks/gallery/arrow.svg' alt='Next Arrow'/>}
                        previousLabel={<img src='/images/blocks/gallery/arrow.svg' alt='Previous Arrow'/>}
                        renderOnZeroPageCount={null}
                        containerClassName="event-index__pagination"
                    /> }
            </>
        );
    }
}

export default OfficeIndex;


const el = document.getElementById('office-index');

if(el)  {
    ReactDOM.render(<OfficeIndex titleTag={el.getAttribute('titleTag')} title={el.getAttribute('titleText')}/>, el);
}
